var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99994 0.469971C5.19675 0.469971 3.73499 1.93174 3.73499 3.73493C3.73499 5.53811 5.19675 6.99988 6.99994 6.99988C8.80311 6.99988 10.2649 5.53811 10.2649 3.73493C10.2649 1.93174 8.80311 0.469971 6.99994 0.469971Z",
    fill: "#FFC805"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04105 7.65283C3.95529 7.65283 2.91114 8.14813 2.29923 8.89378C1.98867 9.27225 1.77035 9.74051 1.75134 10.2595C1.73193 10.7895 1.92325 11.3068 2.3178 11.7583C3.27937 12.8582 4.81464 13.5298 7.00001 13.5298C9.18538 13.5298 10.7207 12.8582 11.6822 11.7583C12.0768 11.3068 12.2681 10.7895 12.2487 10.2595C12.2297 9.74051 12.0114 9.27225 11.7008 8.89378C11.0889 8.14813 10.0448 7.65283 8.95899 7.65283H5.04105Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalNew);
export default __webpack_public_path__ + "static/media/personal-new.22281570.svg";
export { ForwardRef as ReactComponent };